import { ICreateSuggestion, IRespondSuggestion } from '@app-types/websocket/suggestion.types';
import WebSocketClient from '@clients/web-socket.client';
import { SUGGESTION_CHANGE_TYPES, SUGGESTION_REPLY_TYPES } from '../../constants/suggestionTypes';

const socket = WebSocketClient.getInstance();

export function createSuggestion(data: ICreateSuggestion, requestId?:string) {

  const validatedChanges:any[] = [];
  for (const change of data.changes)
  {
      if (change.type === SUGGESTION_CHANGE_TYPES.ADD_SCHEDULE_ENTRY && change.newScheduleEntry)
      {
        change.newScheduleEntry.id = 1;
      }
      validatedChanges.push(change);
  }
  socket.sendJSON({
    requestId,
    newSuggestion: {changes:validatedChanges, chatId:data.chatId, isUpdate:data.isUpdate},
    includeMsg: data.msg
  });
}

export function respondSuggestion(data: IRespondSuggestion) {

  socket.sendJSON({
    suggestionReply: {
      suggestionId:data.suggestionId,
      type:(data.approve?SUGGESTION_REPLY_TYPES.ACCEPT:SUGGESTION_REPLY_TYPES.REJECT),
      isSilent: data.isSilent
    }
  });
}

export function requestSuggestionHistory(scheduleId: number) {

  socket.sendJSON({
    suggestionHistoryRequest: {
      scheduleId
    }
  });
}




// WEBPACK FOOTER //
// ./src/services/suggestion/suggestion.websocket.ts